import { render } from "./BilletCardContainer.vue?vue&type=template&id=23b4d182"
import script from "./BilletCardContainer.vue?vue&type=script&lang=js"
export * from "./BilletCardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__